import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

export enum ViewEntityType {
  report = 1,
  chart
}

@Injectable({
  providedIn: 'root'
})
export class ViewsService {

  constructor(private httpClient: HttpClient) {}

  public getViewsForReports() {
    return this.httpClient.get(`${environment.apis.thirdParty}/views/reports`);
  }

  public getViewsByDayForUsersCharts(timeFilter : string) {
    return this.httpClient.get(`${environment.apis.thirdParty}/views/charts/byday/${timeFilter}`);
  }

  public getReportViewsByTimeFrame(reportId : number, timeFilter : string, vendorId : string, byUser : number) { // 1 for true
    if (!reportId) reportId = 0;
    let query = `${environment.apis.thirdParty}/views/reports/${reportId}?timeFilter=${timeFilter}&byBAC=${byUser}`;
    if (vendorId) query += `&vendorId=${vendorId}`;
    return this.httpClient.get(query);
  }

  public addView(entityId : number, vendorId: string, entityType: ViewEntityType) {
    return this.httpClient.post(`${environment.apis.thirdParty}/views?entityId=${entityId}&vendorId=${vendorId}&type=${entityType}`, {});
  }
}
